"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var _permissionPackages = _interopRequireDefault(require("./permissionPackages.reducer"));

var _portalConnections = _interopRequireDefault(require("./portalConnections.reducer"));

var _portals = _interopRequireDefault(require("./portals.reducer"));

var _portalUsers = _interopRequireDefault(require("./portalUsers.reducer"));

var _tourProperties = _interopRequireDefault(require("./tourProperties.reducer"));

var _portalAdministration = require("./portalAdministration.actions");

Object.keys(_portalAdministration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _portalAdministration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _portalAdministration[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  assignablePermissionPackages: _permissionPackages["default"],
  portals: _portals["default"],
  portalUsers: _portalUsers["default"],
  portalConnections: _portalConnections["default"],
  tourProperties: _tourProperties["default"]
};
exports["default"] = _default;